import { CommonModule } from '@angular/common';
import { Component, Injector, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-image-uploder',
  imports: [CommonModule],
  templateUrl: './image-uploder.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ImageUploderComponent
    }
  ],
  standalone: true,
})
export class ImageUploderComponent implements ControlValueAccessor {
  @Input() multiple: boolean = false;
  @Input() is_required: boolean = false;
  @Input() lebal: any = '';
  @Input() disabled: boolean = false;
  @Input() accept: string = '.jpg,.jpeg,.webp,.png';
  imageSizes: string[] = [];
  @Input() maxFileSize: number = 1;
  images: string[] = [];
  imageNames: string[] = [];
  params: any;
  paramValue: any = {}

  private onChange: any = () => { };
  private onTouched: any = () => { };

  constructor(public ar: ActivatedRoute, private injector: Injector) { }

  ngOnInit(): void {
    this.ar.queryParams.subscribe(params => {
      this.paramValue = params;
    });
  }
  control: any;
  ngAfterViewInit(): void {
    setTimeout(() => {
      const ngControl: NgControl | null = this.injector.get(NgControl, null);
      if (ngControl) {
        this.control = ngControl.control as FormControl;
      } else {
        // Component is missing form control binding
      }
    }, 100);
  }
  writeValue(value: any): void {
    if (value) {
      this.images = this.multiple ? value : [value];
    } else {
      this.images = [];
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  onImageSelected(event: any) {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    const fileArray = Array.from(files);
    const acceptedTypes = this.accept.split(',').map(type => type.trim().toLowerCase());
    const maxSizeBytes = this.maxFileSize * 1024 * 1024;

    for (let file of fileArray) {
      const extension = '.' + file.name.split('.').pop()?.toLowerCase();
      // Check for 'image/*' wildcards or specific extensions
      const isImageWildcard = acceptedTypes.includes('image/*') && file.type.startsWith('image/');

      if (!acceptedTypes.includes(extension) && !isImageWildcard && acceptedTypes.length > 0 && this.accept !== '*') {
        // Simple check, can be improved for MIME types
        if (!acceptedTypes.some(t => file.name.toLowerCase().endsWith(t))) {
          alert(`Invalid file type: ${extension}. Allowed: ${this.accept}`);
          continue;
        }
      }

      if (file.size > maxSizeBytes) {
        const actualSizeMB = (file.size / 1024 / 1024).toFixed(2);
        alert(`"${file.name}" is ${actualSizeMB} MB. Max allowed size is ${this.maxFileSize} MB.`);
        continue;
      }
      const sizeInKB = file.size / 1024;
      const sizeLabel = sizeInKB > 1024
        ? (sizeInKB / 1024).toFixed(2) + ' MB'
        : sizeInKB.toFixed(2) + ' KB';

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const imageData = e.target.result;
        if (this.multiple) {
          this.images.push(imageData);
          this.imageSizes.push(sizeLabel);
          this.imageNames.push(file.name);
          this.onChange(this.images);
        } else {
          this.images = [imageData];
          this.imageSizes = [sizeLabel];
          this.imageNames = [file.name];
          this.onChange(imageData);
        }
      };
      reader.readAsDataURL(file);
    }

    this.onTouched();
  }


  removeImage(index: number) {
    this.images.splice(index, 1);
    this.imageSizes.splice(index, 1);
    this.imageNames.splice(index, 1);
    if (this.multiple) {
      this.onChange(this.images);
    } else {
      this.onChange('');
    }
  }


  view_image(index: number) {
    const file = this.images[index];
    // Check if it's a base64 image or PDF
    const isImage = file.startsWith('data:image');
    const isPdf = file.startsWith('data:application/pdf');

    if (file && (isImage || isPdf)) {
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(
          `<iframe src="${file}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`
        );
      }
    } else {
      // Fallback to download
      const link = document.createElement('a');
      link.href = this.images[index];
      link.download = this.imageNames[index] || `${this.lebal}_Template`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  downloadTemplate() {
  if (this.accept === '.csv') {
    this.downloadCsvTemplate();
  } else if (this.accept === '.pdf') {
    this.downloadPdfTemplate();
  }
}
downloadCsvTemplate() {
  const csvContent = `Name,Email,Phone
John Doe,john@example.com,9876543210
Jane Doe,jane@example.com,9123456789`;

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `${this.lebal || 'template'}.csv`;
  link.click();

  window.URL.revokeObjectURL(url);
}
downloadPdfTemplate() {
  const pdfBase64 = `
JVBERi0xLjMKJcTl8uXrp/Og0MTGCjEgMCBvYmoKPDwKL1R5cGUgL0NhdGFsb2cKL1BhZ2VzIDIgMCBSCj4+CmVuZG9iagoKMiAwIG9iago8PAovVHlwZSAvUGFnZXMKL0tpZHMgWzMgMCBSXQovQ291bnQgMQo+PgplbmRvYmoKCjMgMCBvYmoKPDwKL1R5cGUgL1BhZ2UKL1BhcmVudCAyIDAgUgovTWVkaWFCb3ggWzAgMCA2MTIgNzkyXQovQ29udGVudHMgNCAwIFIKL1Jlc291cmNlcyA8PAovRm9udCA8PAovRjEgNSAwIFIKPj4KPj4KPj4KZW5kb2JqCgo0IDAgb2JqCjw8Ci9MZW5ndGggNTYKPj4Kc3RyZWFtCkJUIAovRjEgMjQgVGYKNTAgNzAwIFRkCihEdW1teSBQREYgVGVtcGxhdGUpIFRqCkVUCmVuZHN0cmVhbQplbmRvYmoKCjUgMCBvYmoKPDwKL1R5cGUgL0ZvbnQKL1N1YnR5cGUgL1R5cGUxCi9CYXNlRm9udCAvSGVsdmV0aWNhCj4+CmVuZG9iagoKeHJlZgowIDYKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDAwMDEwIDAwMDAwIG4gCjAwMDAwMDAwNTYgMDAwMDAgbiAKMDAwMDAwMDEyNSAwMDAwMCBuIAowMDAwMDAwMjQ1IDAwMDAwIG4gCjAwMDAwMDAzMjUgMDAwMDAgbiAKdHJhaWxlcgo8PAovU2l6ZSA2Ci9Sb290IDEgMCBSCj4+CnN0YXJ0eHJlZgo0MDQKJSVFT0Y=
`;

  const byteCharacters = atob(pdfBase64);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `${this.lebal || 'template'}.pdf`;
  link.click();

  window.URL.revokeObjectURL(url);
}




}